import { useEffect, useState } from "react";
import { http } from "./api";

// Liste vivante : activités de base + activités créées par l'entreprise (chargées depuis /api/activities).
export const ACTIVITIES = [
  { code: "ADS", label: "ADS" },
  { code: "SSIAP1", label: "SSIAP 1" },
  { code: "SSIAP2", label: "SSIAP 2" },
  { code: "SSIAP3", label: "SSIAP 3" },
  { code: "cynophile", label: "Agent cynophile" },
  { code: "chef_poste", label: "Chef de poste" },
  { code: "chef_equipe", label: "Chef d'équipe" },
  { code: "referent", label: "Référent" },
];

export const SHIFT_TYPES = [
  { code: "regular", label: "Standard" },
  { code: "night", label: "Nuit" },
  { code: "holiday", label: "Férié" },
  { code: "sunday", label: "Dimanche" },
];

const subs = new Set();
let pending = null;
export const loadActivities = (force = false) => {
  if (!pending || force) {
    pending = http.get("/activities").then((r) => {
      ACTIVITIES.splice(0, ACTIVITIES.length, ...r.data);
      subs.forEach((f) => f());
    }).catch(() => { pending = null; });
  }
  return pending;
};

export const useActivities = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const f = () => tick((x) => x + 1);
    subs.add(f);
    loadActivities();
    return () => subs.delete(f);
  }, []);
  return ACTIVITIES;
};

// Activités cochées pour un site (toutes si aucune sélection) ; garde la valeur courante visible.
export const siteActivities = (site, current) => {
  const codes = site?.activity_codes;
  if (!codes?.length) return ACTIVITIES;
  return ACTIVITIES.filter((a) => codes.includes(a.code) || a.code === current);
};

export const activityLabel = (code) => ACTIVITIES.find((a) => a.code === code)?.label || code;
